import { AgentSearchConfig } from '@tenants/types/tenant';

export const agentSearchConfig: AgentSearchConfig = {
  headerImage: {
    mobileSrc: '/next/assets/images/agent-search/exp-mobile-banner-white-flag.jpg',
    src: '/next/assets/images/agent-search/exp-banner-white-flag.jpg',
    alt: 'American flag background',
  },
  agentTypeName: 'Military Agent',
  featuredAgentDescriptor: 'Military',
  pageTitle: 'Your Military Move Experts We Are Here For You',
  showCountrySelect: false,
};